import moment from "moment";

import { RefreshButton } from "@/Common/Components/Buttons/RefreshButton";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { SettingsButton } from "@/Common/Components/Settings/SettingsButton";
import { SpanControl } from "@/Common/Components/SpanControl";
import { MyleTable } from "@/Common/Components/Tables/MyleTable";
import { MyleTableColumn, MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { MyleTableColumnOrderControlv2 } from "@/Common/Components/Tables/MyleTableColumnOrderControlv2";
import { SimplePagerControl } from "@/Common/Components/Tables/SimplePagerControl";
import { LabActionInboxes, LabActionInboxSortOrderType, SortDirection } from "@/Common/Models/UI/Enums";
import { ColumnConfigurationModel } from "@/Common/Models/UI/Tables/ColumnConfigurationModel";
import { ITableRenderOptions } from "@/Common/Models/UI/Tables/ITableRenderOptions";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LabMessageTableItem } from "@/Labs/Models/LabMessageTableItem";
import { ILabsActionInboxModel } from "@/Labs/Models/UI/ILabsActionInboxModel";
import { LabActionsInboxSettingsContainer } from "./LabActionsInboxSettingsContainer";

interface ILabsActionInboxViewProps {
    Model: ILabsActionInboxModel;
}

class LabsActionViewInboxState {
    public ColumnOrder: string[];
}

class LabsActionInboxView extends React.Component<ILabsActionInboxViewProps, LabsActionViewInboxState> {
    private helper = sessionStore.helper;
    private tableCellClass: string = "text-wrap-control";

    public render(): JSX.Element {
        // prepare The Grid
        const SaveOptionKey = "LabActionGridSettings"; // Unique Key that will be used to Append/Load your Grid Settings in the DataBase in a JSON format to [dbo].[Login].[UserSettings]

        const columnsOptions = this.helper.loadTableColumnOptionsFromSettings(SaveOptionKey, this.GetMyleTableColumnsDefaultOptions() /* Default Options */);

        const tableColumns = this.getTableColumns(columnsOptions); // Add Rendering Functions
        const tableRenderOptions = this.loadTableRenderOptions(columnsOptions); // Table Options
        const cfgm: ColumnConfigurationModel[] = this.helper.castColumnConfigurationToMyleTableColumnOptions(columnsOptions.toArray());

        return (
            <div className="workspace">

                <div className="myle-page-header">
                    <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-3 hidden-sm-down">
                            <p className="header-font-color">{cacheStore.GetString("ActionsLabel")}</p>
                            <h3 className="thin-font">{this.ResolveCurrentInboxName(labsStore.LabsActionInboxModel.get("CurrentInbox"))}</h3>
                        </div>

                        <div className="col-lg-9 col-md-9 col-sm-9">
                            <div className="clearfix" style={{ marginTop: "20px" }}>
                                <div className="pull-right">
                                    <TextboxControl debounceMs={400} value={this.props.Model.get("GlobalActionSearchText")} operation={LocalOperations.Labs.SearchBoxActionInboxTextChanged} style={{ marginRight: "10px", width: "350px" }} className="form-control" placeholder={this.props.Model.get("GlobalActionsearchPlaceholder")} />
                                </div>
                                <div className="pull-right">
                                    <RefreshButton rightMargin={5} onClickOperation={LocalOperations.Labs.OnRefreshClickActionInbox} />
                                    <SettingsButton rightMargin={13} onClickOperation={LocalOperations.Labs.LabActionsInboxSearchSettings_ShowOptionsButtonClick} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="posref" className="ws-scrollable">
                    {this.props.Model.get("LabActionsInboxDisplaySettingsOption") && (
                        <LabActionsInboxSettingsContainer
                            className="filter-component filter-component-responsive"
                            model={this.props.Model}
                            onContainerClick={() => this.onContainerClick()}
                        />
                    )}
                    <div className="myle-doc-tb main-content table-wrapper">
                        <MyleTable
                            TableRenderOptions={tableRenderOptions}
                            TableId="labinbox_main_tb"
                            Columns={tableColumns}
                            DataSource={this.props.Model.get("ActionsTableData")}
                            ColumnsPreferencesChangedOperation={ServerOperations.Server.Myle_UpdateUserSettings}
                            RowClickOperation={LocalOperations.Labs.Table_InboxRowClick}
                            SaveOptionskeyTarget={SaveOptionKey}
                            ColumnSortTarget={MyleTableTarget.Myle_LabActionsInbox_Search_ColumnSortClick}

                        />
                    </div>
                    <div className="clearfix" />
                </div>

                <div className="ws-footer table-pager-footer">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6">
                            <SimplePagerControl
                                PageSize={this.props.Model.get("SelectedPageSizeOption")}
                                TotalRows={this.props.Model.get("TotalQueryRowsFiltered")}
                                CurrentPage={this.props.Model.get("CurrentPage")}
                                EventToDispatchOnPageChange={LocalOperations.Labs.CurrentPageChange}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 text-right" />
                    </div>
                </div>

                {this.props.Model.get("ColumnOrderingPopupOpen") && (
                    <MyleTableColumnOrderControlv2
                        TableColumns={cfgm}
                        SaveOptionskeyTarget={SaveOptionKey}
                        ContainerId="columnSettingsPopup"
                        CloseColumOrder={LocalOperations.Labs.LabActionsInboxColumnOrderingPopup_Close}
                    />
                )}
            </div>
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public loadTableRenderOptions(columnOptions: Immutable.List<MyleTableColumnOptions>): ITableRenderOptions {
        // Get The Render Options
        const defaultTablePluginOptions = {
            MinColWidth: 60,
            MinTableWidth: 980,
            Cols: columnOptions.filter(x => x.IsHidden === false).map(i => i.WidthPercentage),
            FirstColumnNoDrag: true,
            LastColumnNoDrag: true,
            Autoresize: true,
            OnColumnWidthChange: null
        };
        return Immutable.fromJS(defaultTablePluginOptions);
    }

    public ResolveCurrentInboxName(LabInbox: LabActionInboxes): string {
        if (LabInbox == LabActionInboxes.All)
            return cacheStore.GetString("AllLabInbox"); // "All Lab Inbox";
        if (LabInbox == LabActionInboxes.Nurses)
            return cacheStore.GetString("NursesFLabel");// cacheStore.GetString("NewLabsInbox");
        if (LabInbox == LabActionInboxes.Secretaries)
            return cacheStore.GetString("SecretariesFLabel"); // cacheStore.GetString("OnHoldLabsInbox");
        if (LabInbox == LabActionInboxes.Completed)
            return cacheStore.GetString("CompletedFLabel");// cacheStore.GetString("FiledLabsInbox");
    }

    private onContainerClick(): void {
        sessionStore.dispatch(LocalOperations.Labs.LabActionsInboxSearchSettings_OnOkClick);
    }

    private GetMyleTableColumnsDefaultOptions(): MyleTableColumnOptions[] {
        const cols: MyleTableColumnOptions[] = [];

        const c_opt1 = new MyleTableColumnOptions();
        c_opt1.HeaderText = cacheStore.GetString("PrescribedByLabel");
        c_opt1.FieldName = "LabClinician";
        c_opt1.RowClickEnabled = true;
        c_opt1.IsSortable = true;
        c_opt1.SortColumn = LabActionInboxSortOrderType.Prescriber;
        c_opt1.SortDirection = SortDirection.DESC;
        c_opt1.WidthPercentageDefault = 12;

        const c_opt2 = new MyleTableColumnOptions();
        c_opt2.HeaderText = cacheStore.GetString("ActionTaken");
        c_opt2.FieldName = "ActionBy";
        c_opt2.RowClickEnabled = true;
        // c_opt2.IsSortable = true;
        // c_opt2.SortColumn = DocumentSortOrderType.AttachedOnDate;
        // c_opt2.SortDirection = SortDirection.ASC;
        c_opt2.WidthPercentageDefault = 8;

        const c_opt3 = new MyleTableColumnOptions();
        c_opt3.HeaderText = cacheStore.GetString("PatientLabel");
        c_opt3.FieldName = "LabPatient";
        c_opt3.RowClickEnabled = true;
        c_opt3.IsSortable = true;
        c_opt3.SortColumn = LabActionInboxSortOrderType.Patient;
        c_opt3.SortDirection = SortDirection.ASC;
        c_opt3.WidthPercentageDefault = 8;

        const c_opt6 = new MyleTableColumnOptions();
        c_opt6.HeaderText = cacheStore.GetString("DateLabel");
        c_opt6.FieldName = "ActionMinCreationDate";
        c_opt6.RowClickEnabled = true;
        c_opt6.IsSortable = true;
        c_opt6.SortColumn = LabActionInboxSortOrderType.ActionAge;
        c_opt6.SortDirection = SortDirection.DESC;
        c_opt6.WidthPercentageDefault = 8;

        const c_opt7 = new MyleTableColumnOptions();
        c_opt7.HeaderText = cacheStore.GetString("DescriptionLabel");
        c_opt7.FieldName = "MessageSummary";
        c_opt7.RowClickEnabled = true;
        c_opt7.WidthPercentageDefault = 30;

        const c_opt8 = new MyleTableColumnOptions();
        c_opt8.HeaderText = cacheStore.GetString("ActionLabel");
        c_opt8.FieldName = "Actions";
        c_opt8.IsSortable = true;
        c_opt8.SortColumn = LabActionInboxSortOrderType.ActionBy;
        c_opt8.SortDirection = SortDirection.DESC;
        c_opt8.RowClickEnabled = true;
        c_opt8.WidthPercentageDefault = 30;

        const c_opt9 = new MyleTableColumnOptions();
        c_opt9.HeaderText = cacheStore.GetString("ActionAgeLabel");
        c_opt9.FieldName = "ActionAge";
        c_opt9.RowClickEnabled = true;
        c_opt9.IsSortable = true;
        c_opt9.SortColumn = LabActionInboxSortOrderType.ActionAge;
        c_opt9.SortDirection = SortDirection.DESC;
        c_opt9.WidthPercentageDefault = 8;

        cols.push(c_opt1);
        cols.push(c_opt2);
        cols.push(c_opt3);
        cols.push(c_opt6);
        cols.push(c_opt7);
        cols.push(c_opt8);
        cols.push(c_opt9);

        return cols;
    }

    private getTableColumns(columnOptions: Immutable.List<MyleTableColumnOptions>): Immutable.List<MyleTableColumn> {
        const daysLabel = cacheStore.GetString("DayssLabel");

        return MyleTableColumn.buildList<LabMessageTableItem>(
            columnOptions,
            column => {
                switch (column.FieldName) {
                    case "LabClinician":
                        return {
                            renderCell: item => (
                                <div title={item.Model.ClinicianPrescriptorName}> <SpanControl className={this.tableCellClass} text={item.Model.ClinicianPrescriptorName} /></div>
                            )
                        };

                    case "ActionBy":
                        return {
                            renderCell: item => (
                                <div title="2"> <SpanControl className={this.tableCellClass} text={item.StuffedEmployees} /></div>
                            )
                        };

                    case "LabPatient":
                        return {
                            renderCell: item => (
                                <div title={item.Model.PatientName}> <SpanControl className={this.tableCellClass} text={item.Model.PatientName} /></div>
                            )
                        };

                    case "ActionMinCreationDate":
                        return {
                            renderCell: item => {
                                if (item.IsCompletedActionInbox) {
                                    return (
                                        <div title={moment(item.Model.Model.MaxDateCompleted).format("YYYY/MM/DD")}>  <SpanControl className={this.tableCellClass} text={moment(item.Model.Model.MaxDateCompleted).format("YYYY/MM/DD HH:mm")} /> </div>
                                    );
                                }
                                else {
                                    return (
                                        <div title={moment(item.Model.Model.MinDateCreated).format("YYYY/MM/DD")}>  <SpanControl className={this.tableCellClass} text={moment(item.Model.Model.MinDateCreated).format("YYYY/MM/DD HH:mm")} /> </div>
                                    );
                                }
                            }
                        };

                    case "MessageSummary":
                        return {
                            renderCell: item => (
                                <div title={item.Model.Model.RequestSubjects}>  <SpanControl className={this.tableCellClass} text={item.Model.Model.RequestSubjects} /> </div>
                            )
                        };

                    case "Actions":
                        return {
                            renderCell: item => (
                                <div title={item.StuffedActions}>  <SpanControl IsRed={item.IsRedAction && !item.IsCompletedActionInbox} IsGreen={item.IsCompletedActionInbox} IsBold={item.IsBoldAction} className={this.tableCellClass} text={item.StuffedActions} /> </div>
                            )
                        };

                    case "ActionAge":
                        return {
                            renderCell: item => {
                                if (item.IsCompletedActionInbox) {
                                    return (
                                        <div title={item.Model.Model.LastestTaskCompletionInDays.toString() + " " + daysLabel}>  <SpanControl className={this.tableCellClass} text={item.Model.Model.LastestTaskCompletionInDays.toString() + " " + daysLabel} /> </div>
                                    );
                                }
                                else {
                                    return (
                                        <div title={item.Model.Model.OldestTaskNotCompletedInDays.toString() + " " + daysLabel}>  <SpanControl className={this.tableCellClass} text={item.Model.Model.OldestTaskNotCompletedInDays.toString() + " " + daysLabel} /> </div>
                                    );
                                }
                            }
                        };
                }
            },
            false
        );
    }
}

export { LabsActionInboxView };
